"use client";
import clsx from "clsx";
import type { MouseEventHandler, ReactNode } from "react";

type Props = {
  as?: "button" | "span";
  onClick?: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  size?: "default" | "sm" | "icon";
  direction?: "up" | "right" | "down" | "left";
};
export const SecondaryButtonFIT = ({
  as = "button",
  onClick,
  children,
  className,
  type = "button",
  disabled,
  size = "default",
  direction = "right",
}: Props) => {
  const rootClassName = clsx(
    "group/btn rounded-lg border relative overflow-hidden transition-colors disabled:grayscale cursor-pointer disabled:cursor-not-allowed inline-flex items-center justify-center",
    "bg-white border-fit-2 text-tx-1 stroke-tx-1 hover:bg-fit-4/50",
    {
      "h-12 px-6 text-base/5 font-semibold": size === "default",
      "h-10 px-6 text-sm font-semibold": size === "sm",
      "h-10 w-10": size === "icon",
    },
    className,
  );

  const content = (
    <span
      className={clsx("flex justify-center items-center transition-transform whitespace-nowrap", {
        "translate-x-0 group-hover/btn:translate-x-1": direction === "right",
        "translate-x-0 group-hover/btn:-translate-x-1": direction === "left",
        "translate-y-0 group-hover/btn:-translate-y-0.5": direction === "up",
        "translate-y-0 group-hover/btn:translate-y-0.5": direction === "down",
        "gap-2": size === "sm",
        "gap-4": size !== "sm",
      })}
    >
      {children}
    </span>
  );

  if (as === "span") {
    return (
      <span className={rootClassName} aria-disabled={disabled}>
        {content}
      </span>
    );
  }

  return (
    <button type={type} className={rootClassName} onClick={onClick} disabled={disabled}>
      {content}
    </button>
  );
};
